import React, { FC } from 'react';
import TermsTemplate from './termsTemplate';

const TermsChangesPage: FC = () => {
  return <TermsTemplate termsDocument="termsChanges" />;
};

export default TermsChangesPage;
